/** 图片上传体积上限（字节）。 */
export const IMAGE_UPLOAD_MAX_BYTES = 2 * 1024 * 1024;

/** 选图阶段允许的最大体积（与后端 OSS 图片上限对齐，压缩前放行）。 */
export const IMAGE_UPLOAD_SOURCE_MAX_BYTES = 5 * 1024 * 1024;

/** 内容展示图统一提示：比例建议 + 体积限制。 */
export const IMAGE_UPLOAD_CONTENT_HINT = '竖图建议 9:16，横图建议 16:9，文件小于 2M。';

/** 头像、证件等非内容图提示：仅体积限制。 */
export const IMAGE_UPLOAD_SIZE_HINT = '文件小于 2M。';

export type ImageUploadHintVariant = 'content' | 'size-only';

/** 将业务说明与标准上传提示拼接为完整 hint。 */
export function mergeImageUploadHint(
  businessHint?: string,
  variant: ImageUploadHintVariant = 'content',
): string {
  const standardHint = variant === 'content' ? IMAGE_UPLOAD_CONTENT_HINT : IMAGE_UPLOAD_SIZE_HINT;
  const trimmedBusinessHint = businessHint?.trim();
  if (!trimmedBusinessHint) {
    return standardHint;
  }
  return `${trimmedBusinessHint} ${standardHint}`;
}

/** Canvas 压缩时依次尝试的 JPEG 质量档位。 */
export const IMAGE_COMPRESS_QUALITIES = [0.85, 0.75, 0.65, 0.55, 0.45, 0.4] as const;

/** 微信小程序 compressImage 质量档位（0-100）。 */
export const IMAGE_COMPRESS_WEAPP_QUALITIES = [80, 70, 60, 50, 40, 30] as const;

/** 质量压缩仍超标时，依次尝试的画布 / 微信缩放比例。 */
export const IMAGE_COMPRESS_SCALE_FACTORS = [1, 0.85, 0.7, 0.55, 0.45] as const;

/** 短视频上传体积上限（字节）。 */
export const SHORT_VIDEO_UPLOAD_MAX_BYTES = 50 * 1024 * 1024;

/** 故事 / 印象正文视频上传体积上限（字节）。 */
export const CONTENT_VIDEO_UPLOAD_MAX_BYTES = 100 * 1024 * 1024;

/** 微信小程序 compressVideo 质量档位（从高到低）。 */
export const VIDEO_COMPRESS_WEAPP_QUALITIES = ['medium', 'low'] as const;
